import React, { FunctionComponent } from 'react'
import * as S from './styled'
import PackeryDropDown from '../../molecules/PackeryDropDown/PackeryDropDown'
import TimePeriodBox from '../../molecules/TimePeriodBox/TimePeriodBox'
import { Company } from '../../../pages/DashBoard/DashBoardScreen'
import { ProductData } from '../../../redux/requests/products/product.types'
import HouseDropDown from '../../molecules/HouseDropDown/HouseDropDown'
import ProductDropDown from '../../molecules/ProductDropDown/ProductDropDown'
import TimePeriodBoxDropdown from '../../molecules/TimePeriodBoxDropdown/TimePeriodBoxDropdown'
import moment from 'moment'

type OwnProps = {
  setWeeks: React.Dispatch<React.SetStateAction<number>>
  showCalender: boolean
  setShowCalender: React.Dispatch<React.SetStateAction<boolean>>
  setStartDate: React.Dispatch<React.SetStateAction<Date>>
  setEndDate: React.Dispatch<React.SetStateAction<Date>>
  startDate: Date
  endDate: Date
  startDateLocal: Date
  endDateLocal: Date
  setStartDateLocal: React.Dispatch<React.SetStateAction<Date>>
  setEndDateLocal: React.Dispatch<React.SetStateAction<Date>>
  setPackeryFilter: React.Dispatch<React.SetStateAction<Company>>
  productData: ProductData[]
  setHouse: React.Dispatch<React.SetStateAction<number>>
  packeryFilter: Company
  house: number
  product: string
}

type Props = OwnProps

export const FilterBar: FunctionComponent<Props> = ({
  setWeeks,
  showCalender,
  setStartDate,
  setEndDate,
  startDate,
  endDate,
  setPackeryFilter,
  productData,
  setHouse,
  setShowCalender,
  startDateLocal,
  endDateLocal,
  setStartDateLocal,
  setEndDateLocal,
  packeryFilter,
  house,
  product,
}) => {
  const latestData = {
    latestStart: moment(productData?.[0]?.settlementDate, 'YYYY-MM-DD').startOf('day').toDate(),
    latestEnd: moment(productData?.[0]?.settlementDate, 'YYYY-MM-DD').endOf('day').toDate(),
  }

  return (
    <S.Container>
      <ProductDropDown productData={productData} />
      <PackeryDropDown
        setWeeks={setWeeks}
        setPackeryFilter={setPackeryFilter}
        productData={productData}
        packeryFilter={packeryFilter}
      />
      {(product === 'eggs' || product === 'EGGS') && packeryFilter !== Company.ALL && (
        <HouseDropDown
          setHouse={setHouse}
          productData={productData}
          house={house}
          packeryFilter={packeryFilter}
        />
      )}

      <TimePeriodBoxDropdown
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        setShowCalender={setShowCalender}
        setStartDateLocal={setStartDateLocal}
        setEndDateLocal={setEndDateLocal}
        startDate={startDate}
        endDate={endDate}
      />
      <TimePeriodBox
        setWeeks={setWeeks}
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        showCalender={showCalender}
        setShowCalender={setShowCalender}
        startDateLocal={startDateLocal}
        endDateLocal={endDateLocal}
        setStartDateLocal={setStartDateLocal}
        setEndDateLocal={setEndDateLocal}
        latestData={latestData}
      />
    </S.Container>
  )
}

export default FilterBar
